// extracted by mini-css-extract-plugin
export default {"wrapper":"Title_wrapper__i-9NV","line-content":"Title_line-content__ZrJ+U","line":"Title_line__Lu8u4","content":"Title_content__BeIRm"};